module.exports = __webpack_public_path__ + "img/workshops_mobile.e3c463b2.svg";